module.exports = __webpack_public_path__ + "img/bg-left.af7da41a.png";